import { Link } from 'react-router-dom';

const articles = [
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20an%20open%20laptop%20showing%20a%20clean%20spreadsheet%20interface%20with%20soft%20green%20accents%2C%20a%20notebook%20and%20pen%20beside%20it%2C%20a%20white%20ceramic%20coffee%20cup%2C%20warm%20natural%20daylight%20from%20a%20large%20window%2C%20sage%20green%20and%20cream%20color%20palette%2C%20cozy%20Scandinavian%20workspace%2C%20clean%20editorial%20photography%2C%20soft%20shadows%2C%20airy%20atmosphere&width=800&height=600&seq=art-prev-01&orientation=landscape',
    tag: '8 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Guide 2026',
    desc: 'Der vollständige Leitfaden zum OOPBUY Spreadsheet. Erfahren Sie alles über Kategorien, QC, Versand und die besten Tipps für Ihren Einkauf.',
    linkVar: 'primary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-einkaufsguide',
    image: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20shopping%20concept%20with%20a%20person%20holding%20a%20smartphone%20displaying%20a%20clean%20ecommerce%20interface%2C%20beside%20it%20a%20notebook%20with%20handwritten%20checkmarks%20and%20a%20pen%2C%20a%20pair%20of%20white%20sneakers%20nearby%2C%20warm%20natural%20morning%20light%2C%20cozy%20modern%20workspace%20with%20a%20ceramic%20coffee%20cup%2C%20soft%20sage%20green%20and%20cream%20color%20palette%2C%20editorial%20lifestyle%20photography&width=800&height=600&seq=art-prev-02&orientation=landscape',
    tag: '11 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Einkaufsguide',
    desc: 'Schritt für Schritt erklärt: So kaufen Sie mit dem OOPBUY Spreadsheet richtig ein – von der Produktsuche bis zum Versand.',
    linkVar: 'primary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-qc-guide',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20shot%20of%20hands%20carefully%20inspecting%20a%20white%20designer%20sneaker%20on%20a%20clean%20minimal%20desk%20surface%2C%20a%20magnifying%20glass%20and%20checklist%20notebook%20with%20green%20checkmarks%20beside%20it%2C%20soft%20natural%20daylight%20from%20a%20large%20window%2C%20quality%20inspection%20theme%2C%20professional%20product%20review%20aesthetic%2C%20warm%20cream%20and%20beige%20palette&width=800&height=600&seq=art-prev-03&orientation=landscape',
    tag: '7 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet QC Guide',
    desc: 'So funktioniert die Qualitätskontrolle mit dem OOPBUY Spreadsheet. Tipps zur Bewertung von Produktfotos und Verkäufern.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-versand-guide',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20wrapped%20brown%20cardboard%20shipping%20boxes%20tied%20with%20natural%20twine%20on%20a%20light%20wooden%20table%2C%20a%20shipping%20label%20visible%20with%20a%20globe%20icon%2C%20a%20pair%20of%20white%20sneakers%20peeking%20out%20from%20one%20open%20box%2C%20soft%20natural%20daylight%20from%20a%20side%20window%2C%20warm%20cream%20and%20beige%20color%20palette%2C%20editorial%20product%20photography&width=800&height=600&seq=art-prev-04&orientation=landscape',
    tag: '9 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Versand Guide',
    desc: 'Alle Versandoptionen im Vergleich. Lieferzeiten, Kosten und Zollbestimmungen für Deutschland, Österreich und die Schweiz.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-vergleich',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%2C%20two%20minimalist%20desk%20setups%20side%20by%20side%20each%20with%20a%20laptop%20open%20showing%20different%20spreadsheet%20interfaces%2C%20one%20with%20sage%20green%20accents%20and%20the%20other%20with%20warm%20beige%20tones%2C%20clean%20editorial%20photography%2C%20soft%20natural%20daylight%2C%20balanced%20symmetrical%20composition%2C%20modern%20Scandinavian%20workspace&width=800&height=600&seq=art-prev-05&orientation=landscape',
    tag: '10 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Vergleich',
    desc: 'OOPBUY vs. CNFans, Mulebuy, Sugargoo und mehr. Der detaillierte Vergleich der besten Shopping-Agent-Plattformen 2026.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20items%20neatly%20organized%20on%20a%20light%20oak%20shelf%2C%20white%20sneakers%2C%20folded%20beige%20t-shirts%2C%20a%20sage%20green%20hoodie%2C%20minimalist%20clothing%20storage%2C%20warm%20natural%20light%2C%20Scandinavian%20interior%2C%20clean%20and%20tidy%20aesthetic%2C%20editorial%20fashion%20photography%2C%20soft%20neutral%20colors&width=800&height=600&seq=art-prev-06&orientation=landscape',
    tag: '5 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Kategorien Guide',
    desc: 'Entdecken Sie alle 14 Produktkategorien im OOPBUY Spreadsheet – von Schuhen über Hoodies bis zu Accessoires.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=Five%20star%20rating%20concept%20with%20a%20modern%20laptop%20displaying%20a%20review%20interface%20alongside%20a%20pair%20of%20white%20sneakers%20on%20a%20light%20wooden%20desk%2C%20a%20notebook%20with%20handwritten%20product%20reviews%20beside%20it%2C%20warm%20natural%20daylight%2C%20clean%20editorial%20workspace%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20professional%20review%20atmosphere&width=800&height=600&seq=art-prev-07&orientation=landscape',
    tag: '6 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Erfahrungen',
    desc: 'Echte Nutzererfahrungen mit dem OOPBUY Spreadsheet. Was taugt das Tool wirklich? Erfahrungsberichte und Bewertungen aus der Community.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20Weidian%20shopping%20app%20interface%20with%20product%20listings%2C%20placed%20on%20a%20warm%20linen%20surface%2C%20a%20pair%20of%20white%20sneakers%20and%20a%20sage%20green%20notebook%20beside%20it%2C%20soft%20natural%20morning%20light%2C%20modern%20lifestyle%20product%20photography%2C%20warm%20neutral%20palette%2C%20editorial%20style&width=800&height=600&seq=art-prev-08&orientation=landscape',
    tag: '7 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Weidian Guide',
    desc: 'So nutzen Sie das OOPBUY Spreadsheet für Weidian. Die besten Shops, geprüfte Verkäufer und unschlagbare Deals entdecken.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=A%20tablet%20device%20displaying%20a%20Taobao%20shopping%20interface%20with%20product%20images%2C%20placed%20on%20a%20light%20wooden%20desk%2C%20a%20cup%20of%20green%20tea%20beside%20it%2C%20a%20folded%20beige%20linen%20cloth%2C%20warm%20natural%20daylight%20from%20a%20window%2C%20cozy%20minimalist%20workspace%2C%20clean%20modern%20aesthetic%2C%20soft%20warm%20tones&width=800&height=600&seq=art-prev-09&orientation=landscape',
    tag: '8 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Taobao Guide',
    desc: 'Taobao-Einkauf leicht gemacht mit dem OOPBUY Spreadsheet. Finden Sie versteckte Schätze und vertrauenswürdige Verkäufer.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20laptop%20screen%20showing%20a%20B2B%20wholesale%20platform%20interface%20with%20product%20catalogs%2C%20placed%20on%20a%20clean%20minimalist%20desk%2C%20a%20pair%20of%20white%20sneakers%20and%20a%20calculator%20beside%20it%2C%20business%20casual%20atmosphere%2C%20soft%20natural%20daylight%2C%20warm%20beige%20and%20cream%20tones%2C%20professional%20setting&width=800&height=600&seq=art-prev-10&orientation=landscape',
    tag: '6 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet 1688 Guide',
    desc: '1688.com für Einsteiger: Mit dem OOPBUY Spreadsheet die besten Großhandel-Deals finden und sicher bestellen.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=A%20shield%20icon%20concept%20represented%20by%20a%20protective%20glass%20dome%20covering%20a%20smartphone%20and%20a%20wallet%20on%20a%20clean%20light%20desk%20surface%2C%20soft%20natural%20daylight%2C%20safety%20and%20security%20theme%2C%20warm%20neutral%20color%20palette%2C%20minimal%20composition%2C%20professional%20product%20photography%2C%20reassuring%20and%20trustworthy%20atmosphere&width=800&height=600&seq=art-prev-11&orientation=landscape',
    tag: '7 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Sicherheit',
    desc: 'Ist das OOPBUY Spreadsheet sicher? Alles über Datenschutz, vertrauenswürdige Verkäufer und wie Sie Betrug vermeiden.',
    linkVar: 'secondary',
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20limited%20edition%20designer%20sneakers%20in%20cream%20white%20with%20subtle%20olive%20green%20and%20tan%20accents%20displayed%20on%20a%20minimalist%20pedestal%2C%20soft%20dramatic%20side%20lighting%2C%20premium%20product%20photography%20style%2C%20clean%20studio%20background%2C%20visible%20texture%20and%20craftsmanship%20details%2C%20collector%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=600&seq=art-prev-12&orientation=landscape',
    tag: '5 Min. Lesezeit',
    title: 'OOPBUY Spreadsheet Sneaker Guide',
    desc: 'Der ultimative Sneaker-Guide im OOPBUY Spreadsheet. Die besten Batch-Empfehlungen, QC-Tipps und Größenratgeber.',
    linkVar: 'secondary',
  },
];

export default function ArticlePreview() {
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium tracking-wide mb-4">
            Guides & Artikel
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-bold">
            OOPBUY Spreadsheet Ratgeber
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-lg">
            Fundierte Artikel und Anleitungen rund um das OOPBUY Spreadsheet – 
            für Einsteiger und Fortgeschrittene.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles.map((article, index) => (
            <Link
              key={`${article.slug}-${index}`}
              to={article.slug}
              className="group flex flex-col rounded-2xl bg-background-100 overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="relative h-44 sm:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="text-foreground-400 text-xs font-medium">{article.tag}</span>
                <h3 className="mt-1.5 text-foreground-900 text-sm font-semibold leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-foreground-500 text-xs leading-relaxed flex-1 line-clamp-3">
                  {article.desc}
                </p>
                <span className={`mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
                  article.linkVar === 'primary'
                    ? 'bg-foreground-900 text-background-50 hover:bg-foreground-800'
                    : 'bg-transparent border border-foreground-300 text-foreground-700 hover:bg-foreground-50'
                }`}>
                  Artikel lesen
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}